import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Your transaction overview',
  description:
    'These are your transaction details. Make sure to check if this is correct before submitting.',
  claim: 'Claim',
  boxDescription: 'Please submit to claim',
  backToStaking: 'Back to staking',

  notEnoughBalance: 'Your stake balance is 0',
  notHaveEnoughIncentives: 'You do not have enough incentives to claim',
});
